import { useEffect } from "react";
import React from "react";
import "./ProtectedLayout.scss"; // You can add your styles here
import {
  isAuthenticated,
  getSessionCount,
  checkIsTempPwd,
} from "../../../Routes/AuthHelper";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import SecureHeader from "../../SecureHeader/SecureHeader";
import SecureFooter from "../../SecureFooter/SecureFooter";
import { useQuery } from "react-query";
import UserManagmentService from "../../../Services/UsermanagmentService";
import "./ProtectedLayout.scss";
import { OverlayLoader } from "../../Loader/Loader";

const ProtectedLayout = () => {
  const location = useLocation();
  const isAuthentic = isAuthenticated();
  const sessionCount = getSessionCount();
  const isTempPwd = checkIsTempPwd();
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role");

  useEffect(() => {
    if (!isAuthentic)
      navigate("/login", {
        replace: true,
      });
    else if (isTempPwd) {
      navigate("/set-password", {
        replace: true,
      });
    } else if (sessionCount > 0) {
      navigate("/concurrent-sessions", {
        replace: true,
      });
    } else if (
      !["admin", "super_admin"].includes(userRole) &&
      location.pathname.includes("/users")
    ) {
      navigate("/forbidden", {
        replace: true,
      });
    }
  }, [isAuthentic, navigate, sessionCount]);
  useEffect(() => {
    document.body.classList.add("protected");
    return () => {
      document.body.classList.remove("protected");
    };
  }, []);
  const isContainerizedRoute =
    location.pathname.includes("/debit/add") ||
    location.pathname.includes("/debit/edit") ||
    location.pathname.includes("set-password") ||
    location.pathname.includes("/credit/add") ||
    location.pathname.includes("/cholder/credit/add") ||
    location.pathname.includes("/cholder/credit/edit") ||
    location.pathname.includes("/cholder/debit/add") ||
    location.pathname.includes("/cholder/debit/edit") ||
    location.pathname.includes("/credit/edit") ||
    location.pathname.includes("/steps");
  const isCsdAddRoute = location.pathname.includes("/debit/add");
  const isErrorRoute = location.pathname.includes("/not-found");
  const profile_page = location.pathname.includes("/profile");
  const css = `
 .grecaptcha-badge{
  visibility: hidden
}
 `;
  return isAuthentic ? (
    <>
      <style>{css}</style>
      {isContainerizedRoute ? (
        <React.Fragment>
          <div className="protectedLayout">
            <Outlet />
          </div>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <div className="header-outer">
            <div i2c-container="container xl">
              <SecureHeader />
            </div>
          </div>
          {!location.pathname.includes("/concurrent-sessions") ? (
            <div
              className={`${
                profile_page ? "height-class" : "height-class positionRelative"
              } ${isErrorRoute ? "error" : ""}`}
            >
              <div i2c-container="container xl">
                <Outlet />
              </div>
            </div>
          ) : (
            <div className="layout-without-container">
              <Outlet />
            </div>
          )}

          {isErrorRoute ? <SecureFooter /> : ""}
        </React.Fragment>
      )}
    </>
  ) : null;
};

export default ProtectedLayout;
